import {
  BudgetPacingTypes,
  DeliveryInventories,
  DeliveryDevices,
  MenuTargets,
  GoalTypes,
  MinutesOfADay,
  Weekdays,
  PacingTypes,
} from './Constants'

export default {
  CampaignBudget: {
    budget: 0,
    pacingType: PacingTypes.EVEN_PACE,
    dailyLimitBudget: 0,
    evenPacePercentage: 110,
    creativeSchedules: [
      {
        startDate: undefined,
        endDate: undefined,
        creatives: [],
      },
    ],
  },
  Campaign: {
    enablePacingPerBudget: false,
    pacingType: BudgetPacingTypes.EVEN_PACE,
    dailyLimitBudget: 0,
    evenPacePercentage: 110,
    useAdvancedSetting: false,
    deliveryDevices: [DeliveryDevices.TABLET, DeliveryDevices.PHONE],
    deliveryInventories: [DeliveryInventories.MOBILE_APP],
    onlyJapaneseDevice: false,
    weeklyDeliverySchedule: Weekdays.map(day => ({
      day,
      startHour: 0,
      endHour: 23,
    })),
    goalType: GoalTypes.CPC,
    goalValue: 0,
    enableOptimization: true,
    useCreativeSchedule: false,
  },
  MenuSetting: {
    target: [MenuTargets.VISITOR, MenuTargets.RESIDENT],
    minutesAgo: 180 * MinutesOfADay,
    visitCount: 1,
    enableRadiusAutomation: true,
    useLowQualityLocation: true,
    radius: 1000,
    enableBulkSetting: false,
  },
  DemographicSetting: {
    age: ['01', '02', '03', '04', '05', '06'],
    prefecture: [],
  },
  DeliveryLocationGroup: {
    radius: 1000,
  },
}
